import 'babel-polyfill'
import React from "react";
import { Form, Icon, Input, Button, Card, Modal } from "antd";
import { reactLocalStorage } from "reactjs-localstorage";
import "../styles/css/login.scss";
import { login, getLoginCode, loginCode } from "./api/categories";
// import { useTranslation } from 'react-i18next';
import Vconsole from 'vconsole'
class UserLogin extends React.Component {
  constructor() {
    super();
    this.state = {
      playbackVideos: [

        { id: 1, title: "2025-5-11 孙琦", url: "https://xytechsz.com/孙琦.mp4", thumb: "https://xytechsz.com/1.png" },
        { id: 2, title: "2025-5-11 刘艳辉", url: "https://xytechsz.com/刘艳辉.mp4", thumb: "https://xytechsz.com/1.png" },
        { id: 3, title: "2025-5-11 梅开勇", url: "https://xytechsz.com/梅开勇.mp4", thumb: "https://xytechsz.com/1.png" },
        { id: 4, title: "2025-5-11 陈兵", url: "https://xytechsz.com/陈兵.mp4", thumb: "https://xytechsz.com/1.png" },
        { id: 5, title: "2025-5-11 骆新兰", url: "https://xytechsz.com/骆新兰.mp4", thumb: "https://xytechsz.com/1.png" },
        { id: 6, title: "2025-5-11 王超", url: "https://xytechsz.com/王超.mp4", thumb: "https://xytechsz.com/1.png" },
        { id: 7, title: "2025-5-11 林原", url: "https://xytechsz.com/林原.mp4", thumb: "https://xytechsz.com/1.png" },
      ],
      isPlaybackExpanded: false, // 新增：控制是否展开视频列表
      selectedPlaybackUrl: null,
      isAdVisible: false,
      code: "",
      phone: "",
      modelShowY: false,
      TextY: '',
      login: false,
      loading: false,
      collapsed: false,
      loginInfo: {},
      uid: "",
      roomId: "",
      name: "",
      users: [],
      messages: [],
      localAudioEnabled: true,
      localVideoEnabled: true,
      screenSharingEnabled: false,
      vidFit: false,
      brush: false,
      isFullScreen: false,
      FieldsValue: {
        roomId: "",
        displayName: "",
        displayPassword: "",
      },
      roomForm: {
        username: reactLocalStorage.get('username') ? reactLocalStorage.get('username') : "",
        password: reactLocalStorage.get("password") ? reactLocalStorage.get("password") : "",
      },
      models: {
        Text: "",
        modelShow: true,
      },
      roomList: {
        roomId: "",

      },
    };

    this.settings = {
      selectedAudioDevice: "",
      selectedVideoDevice: "",
      resolution: "hd",
      bandwidth: 2048,
      codec: "H264",
    };
    // const vConsole = new Vconsole()


    let settings = reactLocalStorage.getObject("settings");
    if (settings.codec !== undefined) {
      this.settings = settings;
    }

    let logostate = this.getCookie("logostatelocal")
    console.log(logostate)
    if (logostate) {
      // window.location.href="https://alocal.xytechsz.com/#/RoomList"
    }




  }
  openPlaybackModal = (url) => {
    console.log(url);
    this.setState({ selectedPlaybackUrl: url });
  };

  closePlaybackModal = () => {
    this.setState({ selectedPlaybackUrl: null });
  };
  closeAd = () => {
    this.setState({ isAdVisible: false });
  };
  showAd = () => {
    this.setState({ isAdVisible: true });
  };

  hideAd = () => {
    this.setState({ isAdVisible: false });
  };
  downloadDocument = () => {
    window.open("https://test.xytechsz.com/%E6%98%95%E6%98%B1%E7%A7%91%E6%8A%80%E7%97%85%E7%90%86%E5%8D%8F%E4%BD%9C%E7%B3%BB%E7%BB%9F%E6%93%8D%E4%BD%9C%E8%AF%B4%E6%98%8E1.0.0.pdf", "_blank")
  };
  changeLanguage = () => {
    // const { t, i18n } = useTranslation();
    // i18n.changeLanguage(lng);
  }
  componentDidMount = () => {
    // 清除所有cookie
    this.removeAllCookies();

    // 清除所有sessionStorage数据
    this.clearSessionStorage();
    // 设置一个定时器，3秒后显示广告
    this.adTimer = setTimeout(() => {
      this.setState({ isAdVisible: true });
    }, 1000); // 3000 毫秒 = 3 秒	
    // 其他逻辑
    let params = this.getRequest();
    let roomId = "room1";
    let displayName = "";

    let localStorage = reactLocalStorage.getObject("loginInfo");

    if (localStorage) {
      roomId = localStorage.roomId;
      displayName = localStorage.displayName;
    }

    if (params && params.hasOwnProperty("room")) {
      roomId = params.room;
    }
    this.setState({
      FieldsValue: {
        roomId: roomId,
        displayName: displayName,
        displayPassword: "123456",
      },
    });
  };

  componentWillUnmount = () => {
    this.cleanup();
    // 清除定时器以防止内存泄漏
    clearTimeout(this.adTimer);
  };


  removeAllCookies = () => {
    var cookies = document.cookie.split(";");

    for (var i = 0; i < cookies.length; i++) {
      var cookie = cookies[i];
      var eqPos = cookie.indexOf("=");
      var name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;expires=Thu, 01 Jan 1970 00:00:00 GMT";
    }
  };

  clearSessionStorage = () => {
    // sessionStorage.clear();
  };
  cleanup = async () => { };
  userLogin = async (username, password) => {


    const res = await login({
      name: username,
      password: password,
    });
    console.log(res);
    if (res.code == "200") {
      reactLocalStorage.set('username', username)
      reactLocalStorage.set('password', password)
      sessionStorage.setItem("password", res.data.password);
      sessionStorage.setItem("username", res.data.userName);
      sessionStorage.setItem("userName", res.data.phone);
      sessionStorage.setItem("userId", res.data.id);
      sessionStorage.setItem("bigvideo", 1);
      sessionStorage.setItem("times", res.data.times);
      sessionStorage.setItem("activate", res.data.activate);
      sessionStorage.setItem("token", new Date().getTime());
      this.setCookie("logostatelocal", 1, 1)
      this.setCookie("yk", 0)
      this.props.history.push("/UserLogin");
    } else {
      alert("Incorrect username or password");
    }
  };
  validatePhoneNumber = (phone) => {
    // 正则表达式：以1开头，后面跟着10个数字
    const phoneRegex = /^1[3-9]\d{9}$/;
    return phoneRegex.test(phone);
  }
  getLoginCode = async (phone) => {
    if (this.validatePhoneNumber(phone)) {
      console.log("Phone number format is correct");
    } else {
      alert("Incorrect phone number");
    }
    try {
      // 使用 GET 请求，传递参数
      const res = await getLoginCode({
        phone: phone,
      });

      console.log(res);
      if (res.code === "200") {

      } else {
      alert("Incorrect phone number");
        }
      } catch (error) {
        console.error("Request failed:", error);
        alert("Request failed, please try again later");
    }


  };
  loginCode = async (username, password) => {


    try {
      // 使用 GET 请求，传递参数
      const res = await loginCode({
        name: username,
        password: password,
      });

      console.log(res);
      if (res.code === "200") {
        sessionStorage.setItem("username", res.data.userName);
        sessionStorage.setItem("userName", res.data.phone);
        sessionStorage.setItem("userId", res.data.id);
        sessionStorage.setItem("bigvideo", 1);
        sessionStorage.setItem("times", res.data.times);
        sessionStorage.setItem("activate", res.data.activate);
        sessionStorage.setItem("token", new Date().getTime());
        this.setCookie("logostatelocal", 1, 1);
        this.setCookie("yk", 0);
        this.props.history.push("/UserLogin");
      } else {
        alert("Incorrect username or password");
          }
        } catch (error) {
          console.error("Request failed:", error);
          alert("Request failed, please try again later");
    }
  };
  handleSubmit = (e) => {
    e.preventDefault();

    this.userLogin(
      this.state.roomForm.username,
      this.state.roomForm.password
    );
    // getCategoriesAsync;
    // this.props.history.push("/RoomList");
  };
  setCookie = (name, value, iDay) => {
    var oDate = new Date();

    oDate.setDate(oDate.getDate() + iDay);

    document.cookie = name + '=' + value + ';expires=' + oDate;
  }
  getCookie = (name) => {
    var arr = document.cookie.split('; ');
    var i = 0;
    for (i = 0; i < arr.length; i++) {
      var arr2 = arr[i].split('=');

      if (arr2[0] == name) {
        return arr2[1];
      }
    }
    return '';//如果没有就返回空值
  }
  removeCookie = (name) => {
    this.setCookie(name, 0, -1);//将过期时间设置为昨天，系统就自动删除了
  }
  getRequest() {
    let url = location.search;
    let theRequest = new Object();
    if (url.indexOf("?") != -1) {
      let str = url.substr(1);
      let strs = str.split("&");
      for (let i = 0; i < strs.length; i++) {
        theRequest[strs[i].split("=")[0]] = decodeURI(strs[i].split("=")[1]);
      }
    }
    return theRequest;
  }
  inputChangeAdmin(e) {
    this.setState({
      roomForm: {
        username: e.target.value,
        password: this.state.roomForm.password,
      },
    });
  }
  inputChangePassword(e) {
    this.setState({
      roomForm: {
        username: this.state.roomForm.username,
        password: e.target.value,
      },
    });
  }

  handleOk = () => {
    setModalText('The modal will be closed after two seconds');
    setConfirmLoading(true);
    setTimeout(() => {
      setOpen(false);
      setConfirmLoading(false);
    }, 2000);
  };
  handleCancel = () => {
    console.log('Clicked cancel button');
    setOpen(false);
  };
  inputChangeSmsCode = (e) => {
    this.setState({ code: e.target.value })
  };
  inputChangePhoneNumber = (e) => {
    this.setState({ phone: e.target.value })
  };
  // 游客登录
  inputChangeRoomName(e) {
    this.setState({
      roomList: {
        roomId: e.target.value,
      },
    });
  }
  jumpRegister = () => {
    console.log("ss")
    this.props.history.push("/Register")
  };
  handleForgotPassword = () => {
    console.log("ss")
    this.props.history.push("/ForgetPassword")
  };
  goWebsite=()=>{
    window.open("https://xytechsz.com/#/")
  }
  roomSubmit = (e) => {
    e.preventDefault();
    // sessionStorage.setItem('roomId',this.state.roomList.roomId );
    // sessionStorage.setItem('yk',1);
    //    this.props.history.push("/Samples")
    this.props.history.push("/VideoPlayer")
  };
  render() {
    const { getFieldDecorator } = this.state;

    return (
      <div className="login-main">
            
        <div className="login-bg">
         
		      <h1 
		       onClick={() => this.goWebsite()}  
		       className="login-title" 
		       style={{ 
		         position: "fixed", 
		         top: "34px", 
		         fontSize: '56px', 
		         fontWeight: '700',  
		         cursor: 'pointer'
		       }}
		     >
		       <span style={{ color: '#1e518f', fontWeight: 600 }}>昕</span>
		       <span style={{ color: '#ed1c24', fontWeight: 600, marginLeft: 5 }}>昱</span> 
		       <span style={{ color: '#534d4d', fontWeight: 600, marginLeft: 5 }}>科</span> 
		       <span style={{ color: '#534d4d', fontWeight: 600, marginLeft: 5 }}>技</span> 
		       <img src="https://xytechsz.com/static/upload/image/20250313/1741855152347572.png" height="50" />
		     </h1>
          <Form
            onSubmit={this.handleSubmit}
            className="login-form"
            style={{ padding: "35px 120px" }}
          >
		
            <div><a href="https://en.xytechsz.com/" className="oval-button">中文版</a></div>
            <h1 className="login-title">E-Pathology</h1>
          
            <Form.Item
              name="displayName"
              rules={[{ required: true, message: "Please enter your phone number" }]}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                <div style={{ width: "120px" }}>Mobile:</div>
                <Input
                  value={this.state.roomForm.username}
                  onChange={(e) => this.inputChangeAdmin(e)}
                  prefix={<Icon type="team" className="login-input-icon" />}
                  placeholder="Please enter your Mobile"
                />
              </div>
            </Form.Item>
          
            <Form.Item
              name="displayPassword"
              rules={[{ required: true, message: "Please enter your password" }]}
            >
              <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
                <div style={{ width: "120px" }}>Password:</div>
                <Input
                  type="password"
                  value={this.state.roomForm.password}
                  onChange={(e) => this.inputChangePassword(e)}
                  prefix={<Icon type="contacts" className="login-input-icon" />}
                  placeholder="Please enter your password"
                />
              </div>
            </Form.Item>
          
            <Form.Item>
              <Button
                type="primary"
                htmlType="submit"
                className="login-join-button"
              >
                Login
              </Button>
            </Form.Item>
          
            <div style={{ display: 'flex', justifyContent: 'space-between', marginTop: '20px' }}>
              <Button
                type="primary"
                onClick={() => this.jumpRegister()}
                className="registe-join-button"
              >
                Register
              </Button>
              <Button
                type="primary"
                onClick={() => this.handleForgotPassword()}
                className="forgot-password-button"
              >
                Forgot Password
              </Button>
            </div>
            <div style={{ display: 'flex', justifyContent: 'center', marginTop: '20px' }}>
              <div>Recommended to use Google Chrome</div>
            </div>
          </Form>









        </div>
        <div style={{ display: 'flex', justifyContent: 'center', marginTop: '40px', color: "#1890ff" }}>
          <div>Copyright © Shenzhen Xinyu Technology Development (Shenzhen) Co., Ltd. | ICP No. 2022136163</div>

        </div>

        <div>
          <div className="playback-section" style={{
            position: 'fixed', // 固定定位
            top: '30px',       // 距离顶部 20px
            right: '20px',     // 距离右侧 20px
            zIndex: 1000,      // 确保层级足够高，避免被其他内容遮挡
            backgroundColor: '#fff', // 背景颜色（可根据需要调整）
            padding: '10px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)', // 阴影效果（可选）
            borderRadius: '8px', // 圆角效果（可选）
            width: '300px',
            height: '60px',
            cursor: 'pointer'
          }}

            onClick={() => this.downloadDocument()}
          >

            <h2
              style={{ fontSize: '1rem', lineHeight: '40px' }}

            >
              Download the User Manual
            </h2>




          </div>
          <div className="playback-section" style={{
            position: 'fixed', // 固定定位
            top: '110px',       // 距离顶部 20px
            right: '20px',     // 距离右侧 20px
            zIndex: 1000,      // 确保层级足够高，避免被其他内容遮挡
            backgroundColor: '#fff', // 背景颜色（可根据需要调整）
            padding: '10px',
            boxShadow: '0 2px 6px rgba(0,0,0,0.1)', // 阴影效果（可选）
            borderRadius: '8px', // 圆角效果（可选）
            width: '300px',
          }}>
            <h1 style={{ fontSize: '1.3rem', marginBottom: "20px" }} >Live replay:</h1>
            <h2
              style={{ fontSize: '1rem', cursor: 'pointer' }}
              onClick={() => this.setState(prevState => ({ isPlaybackExpanded: !prevState.isPlaybackExpanded }))}
            >
              Yixian Pathology Forum - Guangdong Province Bone Marrow and Neuroendocrine Tumor Pathology Diagnosis Study Class
            </h2>

            <div
              style={{
                overflow: 'hidden',
                maxHeight: this.state.isPlaybackExpanded ? '500px' : '0',
                transition: 'max-height 0.3s ease-out',
              }}
            >

              <div style={{
                display: 'grid',
                gridTemplateColumns: '1fr',
                gap: '16px',
                maxHeight: '400px',
                overflowY: 'scroll',
                padding: '10px',
                boxSizing: 'border-box'
              }}>
                {this.state.playbackVideos.map((video) => (
                  <div
                    key={video.id}
                    onClick={() => this.openPlaybackModal(video.url)}
                    style={{
                      flexShrink: 0,
                      width: '150px',
                      border: '1px solid #ddd',
                      borderRadius: '8px',
                      overflow: 'hidden',
                      boxShadow: '0 2px 6px rgba(0,0,0,0.1)',
                      cursor: 'pointer'
                    }}
                  >
                    <img src={video.thumb} alt={video.title} style={{ width: '100%' }} />
                    <div style={{ padding: '8px', textAlign: 'center' }}>{video.title}</div>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </div>


        <Modal
          title="Live replay playback"
          maskClosable={false}
          mask

          width={1000}


          visible={!!this.state.selectedPlaybackUrl}
          onCancel={this.closePlaybackModal}
          footer={null}
        >
          {this.state.selectedPlaybackUrl && (
            <video controls autoPlay style={{ width: '100%' }}>
              <source src={this.state.selectedPlaybackUrl} type="video/mp4" />
              Your browser does not support video playback。
            </video>
          )}
        </Modal>
      </div>
    );
  }
}

export default UserLogin;
